import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';


const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (
    <div className="App">

      <ResponsiveAppBarAlt />

      <main>

        <Box className="heroWrapper subpage" id="start">

          <img src="Immobilien-verkaufen.webp" className='herobackimg' />
          <Box className='heroWrapperLayer'></Box>
          <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

          </Container>

          <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
            <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
            <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
            <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
            <HashLink className='navItemHero' smooth to="/Blog">Blog</HashLink>
            <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
            <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
          </Box>

          {/* <div className="heroCTAWrapper">
            <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
          </div> */}
        </Box>


        <Box className="mainWrapper">

          <Container maxWidth="lg" className="subPageContainerThin">

            <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Immobilie kaufen oder verkaufen</Typography>


            <Box className="intendTextWrapper">
              <Box className="textintendInnerWrapper">
                <Typography variant='body1' className='sectionText'>Der erste Kauf einer Immobilie als Eigenheim oder als Kapitalanlage wirft oft viele Fragen auf. Unsere Aufgabe als Notare ist es, zeitnah einen Kaufvertragsentwurf zu erstellen und all Ihre Fragen im Beurkundungstermin zu beantworten. Im Anschluss stellen wir einen reibungslosen Übergang des Immobilieneigentums sicher.</Typography>
                <Typography variant='body1' className='sectionText'>Alternativ finden Sie <a target="_blank" href="Angaben_zur_Fertigung_eines_Kaufvertrages_STAND_27.01.2025.pdf">hier</a> ein Formuar zum Herunterladen und, soweit Ihnen die Informationen vorliegen, Ausfüllen. Dieses können Sie uns gern an unsere E-Mail-Adresse info@ht-notare.de übersenden. Fehlende Angaben können auch gern im Nachhinein ergänzt werden. Einen ersten Entwurf erhalten Sie in der Regel noch am selben oder nachfolgenden Tag.</Typography>
                {/* <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/purchase">Kaufvertrag Formular</HashLink></Button> */}
                <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
                <hr className='hoeizontalLine' />
                <Typography variant='body1' className='sectionText'>
                Wenn der Käufer den Kauf über einen Kredit bei einer Bank finanziert, wird die Bank eine Kreditsicherheit in Form einer Grundschuld verlangen. Auch die Bestellung der Grundschuld übernimmt der Notar. Dies kann regelmäßig unmittelbar im Anschluss an die Unterzeichnung des Kaufvertrages im gleichen Termin erfolgen.
              </Typography>
              {/* <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/mortgage">Grundschuld Formular</HashLink></Button> */}
              <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
              </Box>
            </Box>

          </Container>


                             <Box className="map" id="map">
                                                            <Box className="contactMap">
                            
                                                                {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}
                            
                                                                <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                                                    <img src="Karte-HT.webp" className="contactMapImg" />
                                                                    <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                                                </a>
                                                                <Container maxWidth="lg" className="container">
                                                                    <Typography variant='body1' paragraph className="contactMapAddress">
                                                                        Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                                                    </Typography>
                                                                </Container>
                                                                
                                                            </Box>
                                                            {/* <Container maxWidth="lg" id="routelink">
                                                                <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                                            </Container> */}
                            
                                                        </Box>



                            <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

        </Box>

      </main >
      <Footer />
    </div >
  );
};

export default ScrollAnimation;